<template>
  <div style="height:100%;">
    <Modal v-model="isShowSetModal" :mask-closable="false" width="700">
      <p slot="header" style="text-align:center">
        <Icon type="md-create" />
        <span>显示项设置</span>
      </p>
      <!-- <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
      </tr>-->
      <Form label-position="left" :label-width="100" style="margin-left:20px">
        <FormItem label="展示数据">
          <Tag
            :checked="showColumnTitleArray.indexOf(item.title) > -1"
            v-for="item in columnsbackup"
            :name="item.title"
            @on-change="changeColumn"
            size="medium"
            checkable
            color="primary"
          >{{item.title}}</Tag>
        </FormItem>
      </Form>
      <div slot="footer">
        <!-- <Button type="primary" @click="true" style="margin-left: 20px;">确定</Button> -->
      </div>
    </Modal>

    <div class="home-container">
      <div class="home-content">
        <div>
          <!-- <DatePicker format="yyyy-MM-dd" v-model="modalData.timeRange[0]" type="datetime" split-panels placeholder="选择时间"
            style="width: 150px"></DatePicker>
          <Select v-model="modalData.hourRange[0]" style="width:100px">
            <Option v-for="item in hourList" :value="item" :key="item">{{ item }}点</Option>
          </Select>
          <DatePicker format="yyyy-MM-dd" v-model="modalData.timeRange[1]" type="datetime" split-panels placeholder="选择时间"
            style="width: 150px;margin-left: 20px;"></DatePicker>
          <Select v-model="modalData.hourRange[1]" style="width:100px">
            <Option v-for="item in hourList" :value="item" :key="item">{{ item }}点</Option>
          </Select>
          <Select v-model="modalData.timeSelect" style="width:100px;margin-left: 20px;">
            <Option v-for="item in selectList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          -->
          <Row style="white-space:nowrap;">
            <Col
              span="10"
              style="border:3px solid #57A3F3;padding:2px;margin:2px;border-radius: 25px;"
            >
              <div style="margin-left:3%;">
                <br />
                <div>
                  <Select
                    clearable
                    filterable
                    placeholder="选择行政区"
                    v-model="addressfield1"
                    style="width:19%;margin-left:5px"
                  >
                    <Option
                      v-for="item in addressObject.addressfield1"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}</Option>
                  </Select>
                  <Select
                    clearable
                    filterable
                    placeholder="选择小区"
                    v-model="addressfield2"
                    style="width:19%;margin-left:5px"
                  >
                    <Option
                      v-if="item.pid == addressfield1"
                      v-for="item in addressObject.addressfield2"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}</Option>
                  </Select>
                  <Select
                    clearable
                    filterable
                    placeholder="选择楼栋"
                    v-model="addressfield3"
                    style="width:19%;;margin-left:5px"
                  >
                    <Option
                      v-if="item.pid == addressfield2"
                      v-for="item in addressObject.addressfield3"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}</Option>
                  </Select>
                  <Select
                    clearable
                    filterable
                    placeholder="选择单元"
                    v-model="addressfield4"
                    style="width:19%;;margin-left:5px"
                  >
                    <Option
                      v-if="item.pid == addressfield3"
                      v-for="item in addressObject.addressfield4"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}</Option>
                  </Select>
                  <Select
                    clearable
                    filterable
                    placeholder="选择门牌"
                    v-model="addressfield5"
                    style="width:19%;;margin-left:5px"
                  >
                    <Option
                      v-if="item.pid == addressfield4"
                      v-for="item in addressObject.addressfield5"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}</Option>
                  </Select>
                  <!-- <Select filterable placeholder="选择设备地址" v-model="meterAddress" style="width:150px;;margin-left:5px">
                  <Option v-for="item in meterArray" :value="item" :key="item">{{ item }}</Option>
                  </Select>-->
                </div>
                <div style="margin-top:5px">
                  <Input
                    v-model="consumerNumber"
                    style="width:19%;margin-left:5px"
                    placeholder="输入用户编号"
                  />
                  <Input
                    v-model="consumerName"
                    style="width:19%;margin-left:5px"
                    placeholder="输入用户姓名"
                  />
                  <Input
                    v-model="consumerPhone"
                    style="width:19%;margin-left:5px"
                    placeholder="输入用户联系电话"
                  />
                </div>

                <br />
              </div>
            </Col>
            <Col
              span="6"
              style="border:3px solid #57A3F3;padding:2px;margin:2px;border-radius: 25px;"
            >
              <br />
              <div style="margin-left:2%;">
                <!-- <Select v-model="selectMeterType" style="width:100px;margin-left: 20px;margin-right: 20px;">
                  <Option v-for="item in meterTList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>-->
                <Select @on-change="onChangeSearchType" v-model="searchType" style="width:48%;">
                  <Option
                    v-for="item in searchTypeTList"
                    :value="item.value"
                    :key="item.value"
                  >{{ item.label }}</Option>
                </Select>
                <Select v-model="warnType" placeholder="故障类型" style="width:48%;margin-left: 5px;">
                  <Option
                    v-for="(value, key) in stateContrast"
                    :value="key"
                    :key="key"
                  >{{ key + " " + value.replace("空管","报警")}}</Option>
                </Select>
              </div>
              <div style="margin-left:2%;margin-top:5px">
                <!-- <DatePicker v-model="startDate"  type="datetime" placeholder="起始日期" style="width: 200px"></DatePicker>
                <DatePicker v-model="endDate"  type="datetime" placeholder="结束日期" style="width: 200px"></DatePicker>-->
                <DatePicker
                  :disabled="cantSearch"
                  format="yyyy-MM-dd"
                  v-model="modalData.timeRange[0]"
                  type="datetime"
                  split-panels
                  placeholder="选择时间"
                  style="width: 48%"
                ></DatePicker>
                <!-- <Select v-model="modalData.hourRange[0]" style="width:20%">
                  <Option v-for="item in hourList" :value="item" :key="item">{{ item }}点</Option>
                </Select>-->
                <DatePicker
                  :disabled="cantSearch"
                  format="yyyy-MM-dd"
                  v-model="modalData.timeRange[1]"
                  type="datetime"
                  split-panels
                  placeholder="选择时间"
                  style="width: 48%;margin-left: 5px;"
                ></DatePicker>
                <!-- <Select v-model="modalData.hourRange[1]" style="width:20%">
                  <Option v-for="item in hourList" :value="item" :key="item">{{ item }}点</Option>
                </Select>-->

                <!-- <Select filterable placeholder="选择设备地址" v-model="meterAddress" style="width:150px;">
                  <Option v-for="item in meterArray" :value="item" :key="item">{{ item }}</Option>
                </Select>-->
              </div>
              <br />
            </Col>
            <Col span="7">
              <br />
              <div>
                <Button
                  type="primary"
                  icon="ios-search"
                  @click="ok"
                  :loading="okLoading"
                  style="margin-left: 20px;margin-top:5px;width:101px"
                >查询</Button>
                <Button
                  type="primary"
                  @click="isShowSetModal = true"
                  style="margin-left: 20px;float:right;margin-top:5px;width:102px"
                >显示项设置</Button>
              </div>
              <Button
                type="primary"
                @click="exportTable"
                style="margin-left: 20px;width:102px;margin-top:5px;"
              >导出当前页</Button>
              <br />
            </Col>
          </Row>
        </div>
        <div style="margin-top:5px">
          <Table
            ref="table"
            size="small"
            :height="tableHeight"
            :columns="columns"
            :data="tableData"
            :draggable="true"
            border
            highlight-row
          ></Table>
        </div>
        <div style="height:25%;">
          <Divider>表具统计</Divider>
          <Row>
            <span style="margin-right: 30%; font-weight:900">
              <Icon type="md-checkmark-circle" style="color:#19be6b;" size="30" />
              <span style="font-size:25px">正常表具总数量：{{normal}}</span>
            </span>
            <span style="font-weight:900">
              <Icon type="md-close-circle" style="color:#ed4014;" size="30" />
              <span style="font-size:25px">故障表具总数量： {{abnormal}}</span>
            </span>
          </Row>
          <br />
          <Row>
            <span v-for="(value, key) in warnCount" style="margin-right: 20px; font-weight:900">
              <span v-if="value != 0">
                <Icon type="ios-disc" style="color:#ed4014;" size="20" />
                <span
                  style="font-size:18px"
                >{{key.replace('":"'," ").replace("空管 空管","空管 报警") + ": " + value}}</span>
              </span>
            </span>
          </Row>
        </div>
      </div>
    </div>
    <!--Modal v-model="showModal" title="检索条件">
      <Form :model="modalData" label-position="left" :label-width="100">
        <FormItem label="开始时间">
          <DatePicker format="yyyy-MM-dd HH点" v-model="modalData.timeRange[0]" type="datetime" split-panels placeholder="选择时间(精确到小时)"
            style="width: 350px"></DatePicker>
        </FormItem>
        <FormItem label="结束时间">
          <DatePicker format="yyyy-MM-dd HH点" v-model="modalData.timeRange[1]" type="datetime" split-panels placeholder="选择时间(精确到小时)"
            style="width: 350px"></DatePicker>
        </FormItem>
        <FormItem label="时间间隔">
          <Select v-model="modalData.timeSelect" style="width:350px">
            <Option v-for="item in selectList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" long @click="ok" :loading="okLoading">检索</Button>
      </div>
    </Modal-->
  </div>
</template>

<script>
export default {
  name: "warn",
  watch: {
    // selectMeterType(newValue, oldValue) {
    //   let that = this;
    //   that.columns = that.columnsList[newValue];
    // }
  },
  created() {},
  mounted() {
    let that = this;
    that.modalData.timeRange[0] = global.dateFtt("yyyy-MM-dd", new Date());
    that.modalData.timeRange[1] = global.dateFtt("yyyy-MM-dd", new Date());

    // that.selectMeterType = localStorage.getItem('userMeterType');
    window.addEventListener("resize", function() {
      that.tableHeight = (window.innerHeight - 186) * 0.6;
    });
    that.tableHeight = (window.innerHeight - 186) * 0.6;
    that.columns = [
      {
        title: "序号",
        type: "index",
        width: 80,
        align: "center"
      },
      {
        title: "用户编号",
        key: "用户编号",
        resizable: true,
        show: false,
        width: 160
      },
      {
        title: "用户姓名",
        key: "consumerName",
        resizable: true,
        show: false,
        width: 160
      },
      {
        title: "联系电话",
        key: "联系电话",
        resizable: true,
        show: false,
        width: 160
      },
      {
        title: "安装地址",
        key: "安装地址",
        width: 500,
        resizable: true
      },
      {
        title: "表具类型",
        key: "meterType",
        resizable: true,
        width: 160
      },
      {
        title: "表具地址",
        key: "messageAddress",
        resizable: true,
        width: 160
      },
      {
        title: "口径",
        key: "meterCaliber",
        resizable: true,
        width: 160
      },
      {
        title: "报警时间",
        key: "报警时间",
        width: 180
      },
      {
        title: "报警内容",
        key: "报警内容",
        resizable: true,
        width: 500
      }
    ];
    // that.showColumnTitleArray = ['用户编号', '安装地址', '表具类型', '表具地址', '口径', "报警时间", '报警内容'];

    that.columnsbackup = [
      {
        title: "序号",
        type: "index",
        width: 80,
        align: "center"
      },
      {
        title: "用户编号",
        key: "consumerNumber",
        resizable: true,
        show: false,
        width: 160
      },
      {
        title: "用户姓名",
        key: "consumerName",
        resizable: true,
        show: false,
        width: 160
      },
      {
        title: "联系电话",
        key: "consumerPhone",
        resizable: true,
        show: false,
        width: 160
      },
      {
        title: "安装地址",
        key: "安装地址",
        width: 500,
        resizable: true
      },
      {
        title: "表具类型",
        key: "meterType",
        resizable: true,
        width: 160
      },
      {
        title: "表具地址",
        key: "messageAddress",
        resizable: true,
        width: 160
      },
      {
        title: "口径",
        key: "meterCaliber",
        resizable: true,
        width: 160
      },
      {
        title: "报警时间",
        key: "报警时间",
        width: 180
      },
      {
        title: "报警内容",
        key: "报警内容",
        resizable: true,
        width: 500
      }
    ];
    that.generateColumnTitleArray();
    that.getMeterArray();
    that.getAddressEnum();
  },
  data() {
    return {
      cantSearch: true,
      pageName: "warn",
      addressfield1: "",
      addressfield2: "",
      addressfield3: "",
      addressfield4: "",
      addressfield5: "",
      consumerNumber: "",
      consumerName: "",
      consumerPhone: "",
      modalData: {},
      addressObject: {},
      meterArray: [],
      selectMeterType: 0,
      searchType: 0,
      warnType: "",
      startDate: "",
      endDate: "",
      meterAddress: "",
      okLoading: false,
      checkId: "",
      checkArr: [],
      tableHeight: "200",
      showModal: false,
      isShowSetModal: false,
      hourList: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24"
      ],
      meterTList: [
        {
          value: 0,
          label: "水表"
        }
        // ,
        // {
        //   value: 1,
        //   label: '热表'
        // },
        // {
        //   value: 2,
        //   label: '流量表'
        // }
      ],
      searchTypeTList: [
        {
          value: 0,
          label: "最新报警"
        },
        {
          value: 1,
          label: "历史报警"
        }
      ],
      selectList: [
        {
          value: "hour",
          label: "1小时"
        },
        {
          value: "day",
          label: "1天"
        },
        {
          value: "month",
          label: "1月"
        },
        {
          value: "year",
          label: "1年"
        }
      ],
      modalData: {
        timeRange: ["2020-01-15", "2020-01-15"],
        hourRange: ["0", "24"],
        timeSelect: "hour"
      },
      amendTreeData: [
        {
          id: 1,
          title: "行政区",
          expand: true,
          disableCheckbox: true,
          children: [
            {
              id: 2,
              title: "小区",
              expand: true,
              disableCheckbox: true,
              children: [
                {
                  id: 3,
                  title: "楼栋",
                  expand: true,
                  disableCheckbox: true,
                  children: [
                    {
                      id: "00000018003155",
                      title: "00000018003155"
                    },
                    {
                      id: "00000018004345",
                      title: "00000018004345"
                    },
                    {
                      id: "00000018004361",
                      title: "00000018004361"
                    },
                    {
                      id: "00000018004457",
                      title: "00000018004457"
                    },
                    {
                      id: "00000018004523",
                      title: "00000018004523"
                    },
                    {
                      id: "00000018004635",
                      title: "00000018004635"
                    },
                    {
                      id: "00000018004782",
                      title: "00000018004782"
                    },
                    {
                      id: "00000018004789",
                      title: "00000018004789"
                    },
                    {
                      id: "00000018004798",
                      title: "00000018004798"
                    },
                    {
                      id: "00000018004799",
                      title: "00000018004799"
                    },
                    {
                      id: "00000018004850",
                      title: "00000018004850"
                    },
                    {
                      id: "00000018005048",
                      title: "00000018005048"
                    },
                    {
                      id: "00000018005051",
                      title: "00000018005051"
                    },
                    {
                      id: "00000018005064",
                      title: "00000018005064"
                    },
                    {
                      id: "00000018005332",
                      title: "00000018005332"
                    },
                    {
                      id: "00000018005388",
                      title: "00000018005388"
                    },
                    {
                      id: "00000018005401",
                      title: "00000018005401"
                    },
                    {
                      id: "00000018005405",
                      title: "00000018005405"
                    },
                    {
                      id: "00000018005456",
                      title: "00000018005456"
                    },
                    {
                      id: "00000018005462",
                      title: "00000018005462"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      columns: [],
      showColumnTitleArray: [],
      columnsbackup: [],
      tableData: [],
      warnCount: {},
      abnormal: 0,
      normal: "",
      stateContrast: global.stateContrast
    };
  },
  methods: {
    onChangeSearchType() {
      console.log(this.searchType);
      if (this.searchType == 0) {
        this.cantSearch = true;
      } else {
        this.cantSearch = false;
      }
    },
    exportTable() {
      this.$refs.table.exportCsv({
        filename: "监控报警",
        original: false
      });
    },
    getAddressEnum() {
      var that = this;
      that.$axios
        .post("/api/dictionary/selectAddressEnum", {})
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.addressObject = data.body;
          that.addressObject.addressfield5.sort(function(a, b) {
            return (
              a.name.replace("号", "").replace("-", "") -
              b.name.replace("号", "").replace("-", "")
            );
          });
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    generateColumnTitleArray() {
      let titleArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        titleArray.push(this.columnsbackup[i].title);
      }

      this.showColumnTitleArray = titleArray;
      console.log(this.showColumnTitleArray);

      if (
        localStorage.getItem(
          this.pageName + localStorage.getItem("userAccount")
        ) != undefined
      ) {
        this.showColumnTitleArray = JSON.parse(
          localStorage.getItem(
            this.pageName + localStorage.getItem("userAccount")
          )
        );
        var showArray = [];
        for (let i = 0; i < this.columnsbackup.length; i++) {
          let currentObject = this.columnsbackup[i];
          if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
            showArray.push(currentObject);
          }
        }

        this.columns = showArray;
      }
    },
    changeColumn(checked, name) {
      if (checked) {
        // for(let i = 0; i < this.columnsbackup.length; i ++){
        //   let currentObject = this.columnsbackup[i];
        //   if(currentObject.title == name){
        //     this.columns.push(currentObject);
        //     break;
        //   }
        // }
        this.showColumnTitleArray.push(name);
      } else {
        // for(let i = 0; i < this.columns.length; i ++){
        //   let currentObject = this.columns[i];
        //   if(currentObject.title == name){
        //     this.columns.splice(i, 1);
        //     break;
        //   }
        // }
        this.showColumnTitleArray.splice(
          this.showColumnTitleArray.indexOf(name),
          1
        );
      }

      var showArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        let currentObject = this.columnsbackup[i];
        if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
          showArray.push(currentObject);
        }
      }

      localStorage.setItem(
        this.pageName + localStorage.getItem("userAccount"),
        JSON.stringify(this.showColumnTitleArray)
      );

      this.columns = showArray;
    },
    async getMeterArray() {
      var that = this;
      that.$axios
        .post("/api/meter/selectMeterList", {})
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.meterArray = data.body;

          that.selectWarn();
          that.selectCount();
          console.log(data.body);
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    showStateStr(row) {
      let stateArray = JSON.parse(row.messageContent).decode.state;
      let that = this;
      let stateStr = "";
      let meterType = row.meterType;
      Object.keys(stateArray).forEach(function(key) {
        if (
          (meterType == "流量计" ||
            meterType == "水表") &&
          (key == "进水温度传感器" || key == "进水温度传感器")
        ) {
        } else if (stateArray[key] == that.stateContrast[key]) {
          stateStr = stateStr + key + " " + that.stateContrast[key] + "; ";
        }
      });

      return stateStr == "" ? "正常" : stateStr.replace("空管 空管", "空管");
    },
    ok() {
      if (this.startDate == "" || this.endDate == "") {
        this.$Modal.warning({
          title: "提示",
          content: "输入正确参数"
        });

        return;
      }

      this.selectWarn();
    },
    selectedTree(id, flag) {
      this.amendTreeData = this.treeChangeSelected(
        this.amendTreeData,
        id,
        flag
      );
    },
    selectWarn() {
      let resultList = [];
      let that = this;
      var searchObject = {
        addressfield1: that.addressfield1,
        addressfield2: that.addressfield2,
        addressfield3: that.addressfield3,
        addressfield4: that.addressfield4,
        addressfield5: that.addressfield5,
        consumerPhone: that.consumerPhone,
        consumerNumber: that.consumerNumber,
        consumerName: that.consumerName,
        // selectMeterType: that.selectMeterType,
        searchType: that.searchType,
        meterAddress: that.meterAddress,
        meterArray: that.meterArray,
        warnType:
          that.warnType == ""
            ? ""
            : that.warnType + '":"' + that.stateContrast[that.warnType]
      };
      if (
        this.modalData.timeRange[0] &&
        this.modalData.timeRange[1] &&
        this.modalData.hourRange[0] &&
        this.modalData.hourRange[1]
      ) {
        let dateStart = new Date(this.modalData.timeRange[0]);
        // dateStart.setHours(this.modalData.hourRange[0] * 1);
        let dateEnd = new Date(this.modalData.timeRange[1].getTime() + 3600000 * 24);
        // dateEnd.setHours(this.modalData.hourRange[1] * 1);

        that.startDate = dateStart;
        that.endDate = dateEnd;
        if (that.searchType != 0) {
          searchObject.startDate = dateStart;
          searchObject.endDate = dateEnd;
        }
      }

      that.tableData = [];
      that.$axios
        .post("/api/warn/selectWarn", searchObject)
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          let currentArray = data.body;
          let abnArray = [];

          for (let i = 0; i < currentArray.length; i++) {
            let temp = currentArray[i];

            temp["用户编号"] = "\t" + temp.consumerNumber;
            temp["联系电话"] = "\t" + temp.consumerPhone;
            temp["安装地址"] =
              (temp.addressfield1Name == null ? "" : temp.addressfield1Name) +
              (temp.addressfield2Name == null
                ? ""
                : " - " + temp.addressfield2Name) +
              (temp.addressfield3Name == null
                ? ""
                : " - " + temp.addressfield3Name) +
              (temp.addressfield4Name == null
                ? ""
                : " - " + temp.addressfield4Name) +
              (temp.addressfield5Name == null
                ? " "
                : " - " + temp.addressfield5Name);
            temp["报警时间"] =
              "\t" +
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(temp.messageTimestamp)
              );
            temp["报警内容"] = that.showStateStr(temp);
            currentArray[i] = temp;
            if (that.showStateStr(temp) != "正常") {
              // if((that.warnType == "进水温度传感器" || that.warnType == "出水温度传感器")&&(temp.meterType == "水表" || temp.meterType == "流量计")){
              // }else{
              //   abnArray.push(temp);
              // }
              abnArray.push(temp);
            }
          }

          that.tableData = abnArray;
          console.log(that.tableData);

          let abnormal = 0;
          let countObject = {};
          let abnormalAddressArray = [];

          Object.keys(that.stateContrast).forEach(function(key) {
            countObject[key + '":"' + that.stateContrast[key]] = 0;
          });
          console.log(that.meterArray.length);
          for (let i = 0; i < that.tableData.length; i++) {
            let abn = false;
            let currentObject = that.tableData[i];
            console.log(currentObject.meterAddress);
            Object.keys(that.stateContrast).forEach(function(key) {
              if (
                new String(currentObject.messageContent).indexOf(
                  key + '":"' + that.stateContrast[key]
                ) > -1
              ) {
                countObject[key + '":"' + that.stateContrast[key]] =
                  countObject[key + '":"' + that.stateContrast[key]] + 1;
                abn = true;
              }
            });

            if (abn) {
              if(abnormalAddressArray.indexOf(currentObject.meterAddress) == -1){
                abnormal = abnormal + 1;
                abnormalAddressArray.push(currentObject.meterAddress);
              }
              
            }
          }

          that.abnormal = abnormal;
          that.normal = that.meterArray.length - abnormal;
          that.warnCount = countObject;

          console.log("show");
          console.log(data.body);
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    selectCount() {
      let that = this;
      that.$axios
        .post("/api/warn/selectWarn", {
          addressfield1: that.addressfield1,
          addressfield2: that.addressfield2,
          addressfield3: that.addressfield3,
          addressfield4: that.addressfield4,
          addressfield5: that.addressfield5,
          consumerPhone: that.consumerPhone,
          consumerNumber: that.consumerNumber,
          consumerName: that.consumerName,
          startDate: that.startDate,
          endDate: that.endDate,
          selectMeterType: that.selectMeterType,
          searchType: 0,
          meterAddress: that.meterAddress,
          meterArray: that.meterArray,
          warnType:
            that.warnType == ""
              ? ""
              : that.warnType + '":"' + that.stateContrast[that.warnType]
        })
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          let abnormal = 0;
          let countObject = {};

          Object.keys(that.stateContrast).forEach(function(key) {
            countObject[key + '":"' + that.stateContrast[key]] = 0;
          });
          for (let i = 0; i < data.body.length; i++) {
            let abn = false;
            let currentObject = data.body[i];
            Object.keys(that.stateContrast).forEach(function(key) {
              if (
                new String(currentObject.messageContent).indexOf(
                  key + '":"' + that.stateContrast[key]
                ) > -1
              ) {
                countObject[key + '":"' + that.stateContrast[key]] =
                  countObject[key + '":"' + that.stateContrast[key]] + 1;
                abn = true;
              }
            });

            if (abn) {
              abnormal = abnormal + 1;
            }
          }

          that.abnormal = abnormal;
          that.normal = that.meterArray.length - abnormal;
          that.warnCount = countObject;

          // that.tableData = data.body;
          console.log(that.abnormal);
          console.log(that.normal);
          console.log(that.warnCount);
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    treeChangeSelected(treeData, Id, flag) {
      let _this = this;
      for (var i = 0; treeData && i < treeData.length; i++) {
        if (treeData[i].children) {
          treeData[i].children = _this.treeChangeSelected(
            treeData[i].children,
            Id,
            flag
          );
        } else {
          this.$set(treeData[i], "selected", false); //重要！用set方法
          if (Id !== treeData[i].id) {
            //非当前选中设置为未选中
            this.$set(treeData[i], "checked", flag); //重要！用set方法
          } else {
            this.$set(treeData[i], "checked", !flag);
          }
        }
      }
      return treeData;
    },
    changeCheck(res) {
      //单选封装
      if (res.length == 0) {
        this.checkId = "";
        this.checkArr = [];
      } else if (res.length == 1) {
        this.checkId = res[0].id;
        this.checkArr = res[0];
      } else if (res.length > 1) {
        // 需获取与当前缓存不一样的id 赋值到新的id里
        if (this.checkId === "") {
          if (this.parent.pid === res[0].id) {
            this.checkId = res[1].id;
            this.checkArr = res[1];
          } else {
            this.checkId = res[0].id;
            this.checkArr = res[0];
          }
        } else if (res[0].id === this.checkId) {
          this.checkId = res[1].id;
          this.checkArr = res[1];
        } else {
          this.checkId = res[0].id;
          this.checkArr = res[0];
        }
        this.selectedTree(this.checkId, false);
      }
    }
  }
};
</script>

<style scoped>
.home-container {
  padding-top: 5px;
  height: 100%;
}

.home-content {
  height: 100%;
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}

/* 侧边栏 */
aside {
  position: fixed;
  left: 0;
  width: 90px;
  background: #f8f8f9;
  height: 100%;
  transition: width 0.3s;
  overflow: auto;
}

.aside-container {
  height: 100%;
  padding: 10px;
  padding-top: 5px;
}

.aside-content {
  min-height: 100%;
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}

.aside-big {
  position: fixed;
  left: 0;
  background: #f8f8f9;
  height: calc(100% - 151px);
  transition: width 0.3s;
  overflow: auto;
  width: 300px;
}

.min-table /deep/ .ivu-table td {
  height: 0px;
}

.min-table /deep/ .ivu-table-header thead tr th {
  height: 0px;
  padding: 0px;
}
</style>
